export default __webpack_public_path__ + "static/media/android-ctv-removebg-preview.8b9ef06e.png";